import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewScoreComponent } from './review-score.component';

@NgModule({
  declarations: [ReviewScoreComponent],
  imports: [CommonModule],
  exports: [ReviewScoreComponent]
})
export class ReviewScoreModule { }
